// @flow
import * as Loadable from 'react-loadable';
import * as React from 'react';

import Loading from './Loading';

export default function LoadingModule(props: Loadable.LoadingProps) {
  if (props.isLoading) {
    if (props.timedOut) {
      return <div>Loader timed out!</div>;
    } else if (props.pastDelay) {
      return <Loading />;
    }
    return null;
  } else if (props.error) {
    return <div>Error! Component failed to load</div>;
  }
  return null;
}
